import {
  pgTable,
  serial,
  integer,
  text,
  timestamp,
  index,
} from "drizzle-orm/pg-core";
import { createInsertSchema } from "drizzle-zod";
import { z } from "zod";

// Qualifying Life Events
export const qualifyingLifeEvents = pgTable(
  "qualifying_life_events",
  {
    id: serial("id").primaryKey(),
    clientId: integer("client_id").notNull(), // references clients.id
    employeeId: integer("employee_id").notNull(), // references employees.id
    eventType: text("event_type").notNull(),
    eventDate: timestamp("event_date", { withTimezone: false }).notNull(),
    description: text("description").notNull(),
    documentation: text("documentation"),
    documentId: integer("document_id"), // FK to documents.id — uploaded proof file
    status: text("status").notNull().default("pending"), // pending, approved, rejected
    submittedAt: timestamp("submitted_at").defaultNow(),
    allowsChangesUntil: timestamp("allows_changes_until"),
  },
  (table) => {
    return {
      byEmployeeIdx: index("qle_employee_idx").on(table.employeeId),
      byClientIdx: index("qle_client_idx").on(table.clientId),
    } as const;
  }
);

export const insertQualifyingLifeEventSchema = createInsertSchema(
  qualifyingLifeEvents
).omit({ id: true, submittedAt: true });

export type QualifyingLifeEvent = typeof qualifyingLifeEvents.$inferSelect;
export type InsertQualifyingLifeEvent = z.infer<
  typeof insertQualifyingLifeEventSchema
>;


